import type { AppLocale } from "../i18n";

// Existing published company policies; keep one URL source for the login,
// disclosure footer and analytics consent UI. This does not adopt new terms.
export const nexaLegalLinks = (locale: AppLocale) => {
  const language = locale === "ja-JP" ? "ja" : "en";
  const origin = `https://www.nex-a.net/${language}`;
  return {
    privacy: `${origin}/legal/privacy-policy`,
    terms: `${origin}/legal/terms-of-service`,
    operator: `${origin}/about`,
  };
};
